import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { switchMap, catchError, map, tap } from 'rxjs/operators';
import { concat, from, Observable, of } from 'rxjs';
// import { AddErrorToastAction } from './toaster/toaster.actions';
import * as features from './features.actions';
import { HttpService } from '../global/http.service';
import { ToastService } from '../shared/toaster_/toaster_.service';
import { Actions as ActionsCDK } from 'atlas-cdk';

@Injectable()
export class FeatureEffects {
    public constructor(
        private readonly actions$: Actions,
        private readonly http: HttpService,
        private readonly _toasterService: ToastService
    ) { }

    public loadClientConsultants$ = createEffect(() => this.actions$.pipe(
        ofType<features.LoadClientConsultantAction>(features.ActionTypes.LOAD_CLIENT_CONSULTANTS),
        map(action => action.payload),
        switchMap((payload) =>
            this.loadConsultants(payload).pipe(
                map((response) =>
                    new features.LoadClientConsultantSuccessAction(response)
                ),
                catchError(error =>
                    //     from([
                    //     new AddErrorToastAction(error.error.message),
                    //     new features.LoadClientConsultantFailedAction(error)
                    // ])
                    // {
                    //     this._toasterService.launchAlertError(error.error.message, ActionsCDK.error);
                    //     return of(new features.LoadClientConsultantFailedAction(error));
                    // }
                    concat(
                        of(new features.LoadClientConsultantFailedAction(error)),
                        of(null).pipe(
                            tap(() => this._toasterService.launchAlertError(error.error.message, ActionsCDK.error))
                        )
                    )
                )
            )
        )
    )
    );

    private loadConsultants(clientId): Observable<any> {
        return this.http.get(`/clients/user-consultant/${clientId}`);
    }
}
